// Found in CBD/truelle/Gameplay/276---CriticalHitMul
export const criticalHitMul = 2; // eslint-disable-line import/prefer-default-export
